import { Typography } from '@mui/material';
import { faFlaskVial } from '@fortawesome/pro-regular-svg-icons';
import { ActionsSlot, HeaderRoot, Icon, TitleGroup } from './styled';
import type { DrugTestHeaderProps } from './types';

const HEADER_TITLE = 'Drug Test Reports';

const Header = ({ actions }: DrugTestHeaderProps) => {
  return (
    <HeaderRoot>
      <TitleGroup>
        <Icon icon={faFlaskVial} aria-hidden fontSize="medium" />
        <Typography variant="h6" component="h2">
          {HEADER_TITLE}
        </Typography>
      </TitleGroup>
      {actions ? <ActionsSlot>{actions}</ActionsSlot> : null}
    </HeaderRoot>
  );
};

export default Header;
